module.exports = __webpack_public_path__ + "static/media/icon_partner_email.2a9f0b9f.svg";